import { groupLabels } from './group-labels-config';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type { Theme } from '@mui/material/styles';

interface GroupLabelChipsProps {
  currentLabels: { [key: string]: string };
}

export default function GroupLabelChips({
  currentLabels,
}: GroupLabelChipsProps) {
  const activeLabels = groupLabels.filter((label) =>
    Object.prototype.hasOwnProperty.call(currentLabels, label.key)
  );

  if (Object.keys(currentLabels).length === 0) {
    return <Typography fontSize={14}>No labels</Typography>;
  }

  return (
    <Stack
      direction="row"
      spacing={0.5}
      alignItems={'center'}
      sx={{ flexWrap: 'nowrap', overflow: 'hidden' }}
    >
      {activeLabels.map((label) => (
        <Box
          key={label.key}
          sx={(theme: Theme) => ({
            bgcolor:
              theme.palette.mode === 'light'
                ? label.chipStyles.light.bgcolor
                : label.chipStyles.dark.bgcolor,
            px: 1,
            py: 0.5,
            width: 'fit-content',
            borderRadius: 1,
            display: 'inline-block',
            color:
              theme.palette.mode === 'light'
                ? label.chipStyles.light.color
                : label.chipStyles.dark.color,
            flexShrink: 0,
          })}
        >
          <Typography fontSize={12} fontWeight={700}>
            {label.title}
          </Typography>
        </Box>
      ))}
    </Stack>
  );
}
